import { useApiMutation } from "./use-api-mutation";

export function useUpdatePassword() {
  return useApiMutation("post", "/auth/update-password");
}
